<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="m-3">
            <h3>Edit Law</h3>
            <div v-if="pageLoading" class="mt-3">
                Loading...
            </div>
            <EditElement :elementIdProp="pageId" category_id="3"></EditElement>
        </div>
    </div>
</template>

<script>
import EditElement from "@/components/ElementComponents/EditElement";

export default {
    name: 'editLaw',
    components: {
        EditElement,
    },
    data() {
        return {
            pageId: null,
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'All Laws',
                    to: '/laws/all'
                },{
                    text: 'Edit Law',
                    href: '#'}
            ],
        };
    },
    created() {
        this.pageId = this.$route.params.id;
    },
}
</script>